import {wrapper} from 'core/redux/store';
import {useEffect} from 'react';
import {isWebview} from 'core/helpers';
import {loadGAScript} from 'modules/google-analytics/thunks';
import {dayjsInit} from 'core/settings';
import {TNextPageWithLayout} from 'core/types';
import {AppProps} from 'next/app';
import {hydrateRequestId, ISSRRequestIdPageProps, SSR_REQUEST_ID_PROP} from 'core/modules/request-id';

dayjsInit();

// eslint-disable-next-line @typescript-eslint/naming-convention
export const useAppState = ({Component, rest}: {Component: TNextPageWithLayout; rest: Omit<AppProps, 'Component'>}) => {
    const {store, props} = wrapper.useWrappedStore(rest);

    const pageProps = props.pageProps as ISSRRequestIdPageProps | undefined;
    hydrateRequestId(pageProps?.[SSR_REQUEST_ID_PROP]);

    const designType = store.getState().articles.designType;

    const getLayout = Component.getLayout;
    const env = process.env.NODE_ENV;

    useEffect(() => {
        if (!isWebview() && 'development' !== env) {
            store.dispatch(loadGAScript());
        }
    }, [store, env]);

    return {
        props,
        store,
        getLayout,
        designType,
    };
};
